module.exports = __webpack_public_path__ + "img/15.5575e017.svg";